import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}
export function Modal({
  isOpen,
  onClose,
  children,
  className = ''
}: ModalProps) {
  // Handle escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-187">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-6" data-id="element-188">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-base-950/90 backdrop-blur-md" data-id="element-189" />

          {/* Modal Content */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        duration: 0.5
      }} className={`relative w-full bg-slate-900 border border-slate-700 shadow-2xl overflow-hidden clip-corner ${className}`} data-id="element-190">
            {/* Scan line animation */}
            <div className="absolute inset-0 pointer-events-none overflow-hidden z-20" data-id="element-191">
              <div className="w-full h-[2px] bg-gold-400/20 shadow-[0_0_10px_rgba(196,162,101,0.4)] animate-scanline" data-id="element-192"></div>
            </div>

            {/* Top Accent Bar */}
            <div className="h-1 w-full bg-gradient-to-r from-gold-500 via-gold-300 to-gold-500" data-id="element-193"></div>

            <button onClick={onClose} className="absolute top-4 right-4 text-slate-400 hover:text-white transition-colors z-30 p-2" aria-label="Close modal" data-id="element-194">
              <X className="w-5 h-5" data-id="element-195" />
            </button>

            <div className="relative z-10 h-full max-h-[85vh] overflow-y-auto custom-scrollbar" data-id="element-196">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}